import { Component, OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';

import { JobSearchService } from '../../../../../../../UI/src/app/shared/job-search/job-search.service';
import { FacetContainer, SavedSearchFilter, Facet } from '../../../../../../../UI/src/app/shared/job-search/job-results.dto';
import { JobAlertComponent } from '../../../job-alert/job-alert.component'
import { BrandingService } from '../../../../../../../UI/src/app/shared/branding/branding.service';
import { Storage } from '../../../../../../../UI/src/app/shared/constants';
import { AuthenticationService } from '../../../../../../../UI/src/app/shared/authentication/authentication.service';
import { JobAlertService } from '../../../../../../../UI/src/app/shared/job-alert/job-alert.service';
import * as moment from 'moment/moment'; 

enum PageMode {
  FilterMode,
  SaveMode,
  AddMode
};

@Component({
  selector: 'sts-page-job-filter',
  templateUrl: 'job-filter.component.html'
})
export class JobSearchFilterComponent implements OnInit {
  public dateFormat: any;
  facetContainers: FacetContainer[];
  selectedFacet: String;
  addToFacet: FacetContainer;
  selectedFilter: String;
  savedSearches: SavedSearchFilter[];
  selectedSavedSearch: number;
  pageMode: number;
  PageEnum = PageMode;
  facetOptions: FacetContainer;
  searchCriteriaName: string;
  dateFacet = {
    fromDate: null,
    toDate: (new Date()).toISOString()
  };
  isLoggedIn = false;
  
  constructor(
    public navCtrl: NavController,
    public jobsSearchService: JobSearchService, 
    private brandingService: BrandingService,
    private authService: AuthenticationService,
    private jobAlertService: JobAlertService,
  ) {
    var culture = window.localStorage.getItem(Storage.CULTURE);
    this.dateFormat = moment.localeData(culture).longDateFormat('L');
    this.isLoggedIn = this.authService.isUserLoggedin();
  
  }

  ngOnInit() {
    this.facetContainers = this.jobsSearchService.getFilterFacets();
    this.selectedSavedSearch = this.jobsSearchService.getSavedSearchId();
    this.pageMode = PageMode.FilterMode;
    if(this.isLoggedIn) {
      this.jobsSearchService.fetchSavedSearches().then((res) => {
        this.savedSearches = res;
      });
    }
    this.selectFirstFacet();
  }

  resetFilters() {
    this.jobsSearchService.clearFilters();
    this.selectedSavedSearch = null;
    this.jobsSearchService.resetJobs().then((res) => {
      if (res === true) {
        this.ngOnInit();
      }
    });
  }

 

  saveSearch() {
    if (this.pageMode !== PageMode.SaveMode) {
      this.pageMode = PageMode.SaveMode;
    } else {
      this.jobsSearchService.fillInFilters(this.facetContainers, this.getDateFilters());
      this.jobsSearchService.saveSearchFilters(this.searchCriteriaName).then(
        res => {
          this.jobsSearchService.fetchSavedSearches().then((results) => {
            this.savedSearches = results;
          });
          this.pageMode = PageMode.FilterMode;
        }
      );
    }
  }

  showMoreFacets (fc: FacetContainer) {
    this.addToFacet = fc;
    if (fc.showLess  == null) {
      this.jobsSearchService.fetchNextFacetItems(fc.facetName).then((res: FacetContainer) => {
        if (res != null) {
          for (let i = 0; i < res.facetItems.length; i++) {
            const item = res.facetItems[i];
            if (this.addToFacet.facetItems.findIndex(f => f.name === item.name) !== -1) {
              continue;
            }
            item.filterQuery = { name: this.addToFacet.facetName, searchFieldName: this.addToFacet.fieldName, value: item.name };
            item.isHidden = false;
            this.addToFacet.facetItems.push(item);
          }
         this.addToFacet.showLess = true;
        }
      });
    } else if (!fc.showLess) {
      for (let j = this.addToFacet.facetLimit; j < this.addToFacet.facetItems.length; j++) {
        this.addToFacet.facetItems[j].isHidden = false;
      }
      this.addToFacet.showLess = true;
    } else {
      for (let k = this.addToFacet.facetLimit; k < this.addToFacet.facetItems.length; k++) {
        this.addToFacet.facetItems[k].isHidden = true;
      }
      this.addToFacet.showLess = false;
    }
  };

  cancelSaveMode() {
    this.pageMode = PageMode.FilterMode;
    this.facetOptions = null;
  }

  searchThroughSaved($event) {
    this.jobsSearchService.loadSavedSearch(this.selectedSavedSearch)
      .then(res => {
        if (res === true) {
          this.filterNavigateBack(false);
        }
      });
  }

  filterNavigateBack(shouldPopulateFilters) {
    if (shouldPopulateFilters) {
      this.jobsSearchService.fillInFilters(this.facetContainers, this.getDateFilters());
    }
    this.navCtrl.pop({ direction: 'forward', animation: 'ios-transition' });
  }

  selectFacet(name: string) {
    this.selectedFacet = (this.selectedFacet === name) ? '' : name;
  }

  private selectFirstFacet() {
    if (this.facetContainers.length > 0) {
      this.selectedFacet = this.facetContainers[0].fieldName;
    }
  }

  private getDateFilters(){
    const isToChanged = (new Date(this.dateFacet.toDate).getDate() != (new Date()).getDate()); 
    if(this.dateFacet.fromDate || isToChanged)
      return [new Date(this.dateFacet.fromDate), new Date(this.dateFacet.toDate)];
    else return null;
  }

  getlogo() {
    return this.brandingService.getMobileLogoUrl();
  }

  getActiveItems(container : FacetContainer) {
    return container.facetItems.filter(i => !i.isHidden);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/job-search/components/job-filter/job-filter.component.ts